<script setup lang="ts">
import AppImage from '@/components/common/AppImage.vue'
import OfficialMerchantBadge from '@/components/common/OfficialMerchantBadge.vue'
import ShopGuaranteed from '@/components/common/shop/ShopGuaranteed.vue'
import { useScreenSize } from '@/composables/screen-size'
import useProductStore from '@/stores/product'
import { AppBlock } from 'lilasia-ui'
import { storeToRefs } from 'pinia'

const { isMobile } = useScreenSize()
const productStore = useProductStore()
const { selectedProduct } = storeToRefs(productStore)
</script>

<template>
  <div
    v-if="selectedProduct?.shop"
    class="relative"
  >
    <AppImage
      src="/images/common/default-official-merchant-banner.png"
      alt="Lilasia Official Merchant Banner"
      :width="262"
      :height="172"
      class="h-[158px] w-full rounded-16 object-cover object-top md:h-[148px] lg:h-[160px]"
    />
    <div class="absolute inset-8 flex flex-col items-center gap-8">
      <AppBlock
        :rounded="undefined"
        class="w-full rounded-[10px]"
      >
        <div class="flex items-center gap-8">
          <RouterLink :to="{ name: 'shops.show', params: { slug: selectedProduct.shop.slug } }">
            <div class="flex items-center gap-8 p-8 pr-8">
              <AppImage
                :src="String(selectedProduct.shop.logo_thumbnail_url)"
                :alt="String(selectedProduct.shop.name)"
                :width="60"
                :height="60"
                class="h-[60px] w-[60px] rounded-8 border border-black-10 object-scale-down"
              />
              <div class="space-y-4">
                <div
                  class="text-16 font-600 leading-20"
                  :class="{ 'line-clamp-1': isMobile }"
                >
                  {{ selectedProduct.shop.display_name }}
                </div>
                <OfficialMerchantBadge class="w-fit" />
              </div>
            </div>
          </RouterLink>
        </div>
      </AppBlock>

      <ShopGuaranteed
        small
        class="m-auto"
      />
    </div>
  </div>
</template>
